import {defineTokens} from '@chakra-ui/react3'

const chakraRadii = defineTokens.radii({
    none: {value: '0'},
    '2xs': {value: '0.0625rem'},
    xs: {value: '0.125rem'},
    sm: {value: '0.25rem'},
    md: {value: '0.375rem'},
    lg: {value: '0.5rem'},
    xl: {value: '0.75rem'},
    '2xl': {value: '1rem'},
    '3xl': {value: '1.5rem'},
    '4xl': {value: '2rem'},
    full: {value: '9999px'}
})

const leapRadii = defineTokens.radii({
    none: {value: '0px'},
    xs: {value: '0.25rem'},
    s: {value: '0.5rem'},
    m: {value: '0.75rem'},
    l: {value: '1rem'},
    xl: {value: '1.5rem'},
    round: {value: '9999px'}
})

export const radii = defineTokens.radii({
    ...chakraRadii,
    ...leapRadii
})
